import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '@core/services/authentication.service';
import { TalentLocale } from '@models/locales';

@Pipe({
  name: 'plural',
})
@Injectable({
  providedIn: 'root',
})
export class PluralPipe implements PipeTransform {
  private _userLocale: TalentLocale;

  constructor(private readonly _authService: AuthenticationService) {
    this._authService.currentUser$.subscribe(
      (user) => (this._userLocale = user.locale),
    );
  }
  transform(translationKey: string, value: number): string {
    if (!translationKey || typeof translationKey !== 'string') {
      throw new Error(
        'Plural pipe: A translation key is required and must be a string',
      );
    } else if (value === undefined || typeof value !== 'number') {
      throw new Error('Plural pipe: A value is required and must be a number');
    }
    if (Math.abs(value) > 1 || (value === 0 && this._userLocale !== 'fr')) {
      return `${translationKey}.other`;
    } else {
      return `${translationKey}.one`;
    }
  }
}
